export const SnackbarTypes = Object.freeze({
  Info: "info",
  Export: "export",
  ExportSuccess: "export-success",
  Download: "download",
  DownloadSuccess: "download-success",
  Success: "success",
  Error: "error",
});
